import { useCallback, useEffect, useRef, useState } from 'react';

const INITIAL_VALUE = {
  showLeftFade: false,
  showRightFade: false,
};

const useHorizontalScrollFade = (enabled: boolean, deps: unknown[] = []) => {
  const [showFade, setShowFade] = useState(INITIAL_VALUE);

  const { showLeftFade, showRightFade } = showFade;

  const scrollContainerRef = useRef<HTMLDivElement | null>(null);

  const updateFade = useCallback(() => {
    const el = scrollContainerRef?.current;

    if (!el) return;

    const { scrollLeft, scrollWidth, clientWidth } = el;

    const scrollLeftAbs = Math.abs(scrollLeft);

    const scrollRight = scrollWidth - clientWidth - scrollLeftAbs;

    setShowFade({
      showLeftFade: scrollLeftAbs > 1,
      showRightFade: scrollRight > 1,
    });
  }, []);

  useEffect(() => {
    const el = scrollContainerRef?.current;

    if (!enabled || !el) {
      setShowFade(INITIAL_VALUE);
      return;
    }

    updateFade();

    el.addEventListener('scroll', updateFade, { passive: true });
    window.addEventListener('resize', updateFade);

    return () => {
      el.removeEventListener('scroll', updateFade);
      window.removeEventListener('resize', updateFade);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, ...deps]);

  return { showLeftFade, showRightFade, scrollContainerRef };
};

export default useHorizontalScrollFade;
